import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteResourceCard } from 'bundles/ent-website/queries/EntWebsiteResourceHub';
import { basicCardFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteFeaturedContentFragment = contentfulGql`#graphql
  ${basicCardFragment}
  ${entWebsiteResourceCard}
  fragment EntWebsiteFeaturedContent on EntWebsiteFeaturedContent {
    slug
    mainCard {
      ...BasicCard
    }
    featuredResourceCardsCollection {
      items {
        ...EntWebsiteResourceCard
      }
    }
  }
`;

export const entWebsiteBlockFeaturedContentQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteFeaturedContentFragment}
  query entWebsiteBlockFeaturedContent($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteFeaturedContent
      }
    }
  }
`;
